import { createFileRoute } from "@tanstack/react-router";
import { CourseEditor } from "./-components/course-editor";

export const Route = createFileRoute("/_authenticated/_workforce/training/courses/new")({
  component: NewCourse,
});

/** A course starts as a draft; publishing is a separate, checked step. */
function NewCourse() {
  return <CourseEditor course={null} />;
}
